import React, { Fragment,Component } from "react";
import Navbar from "../Navbar";
import Sidenav from "../Sidenav";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Navlink from "../wrappers/Navlink";
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider'; 
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline'; 
import Hidden from '@material-ui/core/Hidden';
import { MAPCLIENT_URL_DOMAIN } from "../../utils/constants";

const drawerWidth = 240;

const styles = theme => ({
    root: {
      display: 'flex',
    },
    drawer: {
      [theme.breakpoints.up('sm')]: {
        width: drawerWidth,
        flexShrink: 0,
      },
    },
    appBar: {
      marginLeft: drawerWidth,
      [theme.breakpoints.up('sm')]: {
        width: `calc(100% - ${drawerWidth}px)`,
      },
    },
    menuButton: {
      marginRight: 20,
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
    },
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
      width: drawerWidth,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing.unit * 3,
    },
  });

class MainWrapper extends Component  {

  constructor(props, context) {
    super(props, context);
    this.state={
        uMenu: false,
        isLayerDisable: true,
        userRoles:[],
        apiKey: localStorage.apiKey,
        m2: 'none',
        m1:'none',
    mobileOpen: false,
    } 
}


static getDerivedStateFromProps(props, state) {  
  if (props.userRoles.userRoles.includes(1)) {
    return{
        m2: 'none',
        m1: 'block',
    };
} else {
    return{
        m2: 'block',
        m1: 'none',
    }
}
}
  
  handleDrawerOpen = () => {
    this.setState({ mobileOpen: true });
  };

  _signOut = () => {
 //   console.log(this.props)
    localStorage.clear();
    if(this.props !== undefined)
    {
        if(this.props.history !== undefined)
        {
            this.props.history.push("/");
        }
        else
        {
        this.context.router.history.push("/");
        }
    }
    else
    {
    this.context.router.history.push("/");
    }
};

  handleDrawerClose = () => {
    this.setState({ mobileOpen: false });
  };

  
  render() {
    const { classes, theme } = this.props;

    const drawer = (
      <div>
        <div className={classes.toolbar} />
        <Divider />
        
        <Navlink className="nav-link" to="/dashboard">
                <i className="fas fa-chart-line classes.heading" />Dashboard
              </Navlink>
          <ExpansionPanel style={{ display: `${this.state.m1}` }}>
                
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography ><i  />Users</Typography>
                    </ExpansionPanelSummary>
                        <div >
                            <List component="nav">
                                <Navlink className="nav-link" to="/users">
                                    <ListItem button>
                                            Users
                                    </ListItem>
                                </Navlink>
                                <Divider light />
                                <Navlink className="nav-link" to="/users/main">
                                    <ListItem button>
                                        Main Users
                                    </ListItem>
                                </Navlink>
                                <Divider light />
                                <Navlink className="nav-link" to="/users/plain">
                                    <ListItem button>
                                        Plain Users
                                    </ListItem>
                                </Navlink>
                            </List>
                        </div>
                        {/*
                        <div>
                        <ExpansionPanelSummary expanded={false}>
                            <Typography className={classes.heading}><i className="fas fa-list-ul" />My License</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelSummary  expanded={false}>
                        <Typography className={classes.heading}><i className="fas fa-list-ul" /><a href={`http://localhost:50568/app/index.html?apikey=` + this.state.apiKey} 
                          target="_blank">Go to Map</a></Typography>
                        </ExpansionPanelSummary>
                        </div>
                        */}  
                    </ExpansionPanel>
                    
                    <List component="nav">
                    <ListItem button>
                    <Navlink className="nav-link" to="/hotspotsfile">
                        <i className="fas fa-chart-line classes.heading" />Hotspot Files
                    </Navlink> 
                    </ListItem>
                    
                    <ListItem button>
                    <Navlink className="nav-link" to="/company">
                        <i className="fas fa-chart-line classes.heading" />Companies
                    </Navlink> 
                    </ListItem>
                    
                    <ListItem button>
                    <Navlink className="nav-link" to="/users">
                        <i className="fas fa-chart-line classes.heading" />Users
                    </Navlink> 
                    </ListItem>
                    
                    <ListItem button>
                    <Navlink className="nav-link" to="/rawmodis">
                        <i className="fas fa-chart-line classes.heading" />Raw MODIS
                    </Navlink> 
                    </ListItem>

                    <ListItem button>
                    <Navlink className="nav-link" to="/rawviirs">
                        <i className="fas fa-chart-line classes.heading" />Raw VIIRS
                    </Navlink> 
                    </ListItem>
                    
                    <ListItem button>
                    <Navlink className="nav-link" to="/filtered">
                        <i className="fas fa-chart-line classes.heading" />Filtered Data
                    </Navlink> 
                    </ListItem>
                    
                    <ListItem button>
                    <Navlink className="nav-link" to="/reportlist">
                        <i className="fas fa-chart-line classes.heading" />Report Listing
                    </Navlink>
                    </ListItem>
                    
                    <ListItem button>
                    <Navlink className="nav-link" to="/emaillist">
                        <i className="fas fa-chart-line classes.heading" />Email Listing
                    </Navlink>
                    </ListItem>
                    
                    <ListItem button>
                    <Navlink className="nav-link" to="/gotomap">
                        <i className="fas fa-chart-line classes.heading" />View In Map
                    </Navlink> 
                    </ListItem>
                    
                    </List>
                 {/*}   <Navlink className="nav-link" to={`http://` + MAPCLIENT_URL_DOMAIN+`/app/index.html?k=` + this.state.apiKey+ `&ses=`+ localStorage.sessionKey}  target='_blank'>
                        <i className="fas fa-chart-line classes.heading" />Go to Map
                    </Navlink>
                  */}
      </div>
    );

    return (
      <div className={classes.root}>
        <CssBaseline />
        <AppBar position="fixed" className={classes.appBar} style={{backgroundColor: '#F79644'}} >
        <Toolbar disableGutters={!this.state.mobileOpen} style={{width:'100%'}}>
          <IconButton  color="inherit"   onClick={this.handleDrawerOpen} aria-label="Menu"
              className={classes.menuButton}>
            <MenuIcon />
          </IconButton>
          <div style={{float:'left',position:'relative', width:'50%'}}>
          <Typography  style={{color: '#000'}} variant="h5" noWrap>Hotspot User Panel</Typography>
          </div>
          <div style={{position:'relative', width:'50%'}}>
          <Button color="secondary" variant="contained" onClick={this._signOut} style={{float:'right',marginRight:20,color: '#000'}}  > Sign Out</Button>
          </div>
        </Toolbar>
      </AppBar>
     
        <nav className={classes.drawer}>
          {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
          <Hidden smUp implementation="css">
          <Drawer 
    variant="temporary"
    anchor={theme.direction === 'rtl' ? 'right' : 'left'}
    open={this.state.mobileOpen}
    classes={{
      paper: classes.drawerPaper,
    }}
     
    > 
            <IconButton onClick={this.handleDrawerClose}>
              <ChevronLeftIcon />  
            </IconButton>
            
            {drawer}
           
         
    </Drawer>
           
          </Hidden>
          
          <div style={{ display:`${this.props.isDisplayOn}` }} className="loadingSpinner"></div>

          <Hidden xsDown implementation="css">
            <Drawer
              classes={{
                paper: classes.drawerPaper,
              }}
              variant="permanent"
              open
            >
              {drawer}
            </Drawer>
          </Hidden>
        </nav>
        <main className={classes.content}>
        
          <div className={classes.toolbar} />
          {this.props.children}
          <Typography paragraph>
        
          </Typography>
          <Typography paragraph>
          
          </Typography>
        </main>
        
   
      </div>
    );
  };

}

export default withStyles(styles,{withTheme: true})(MainWrapper);


/*
  render(){ 
  const { open } = this.state;
  return (
    /* <Button color="inherit" onClick={this._signOut}> Sign out</Button> 
     <div className="container-fluid">
        <div className="row">
       
         
        </div>
        
    <main role="main" className="col-md-9 ml-sm-auto col-lg-10 px-4">
           
          </main>
        
    <Sidenav
            isDisplayOn={this.props.isDisplayOn}
            userRoles={this.props.userRoles}
            notExpiredPackage={this.props.getNotExpiredPackages} />
        
       <Fragment>
      
     
       </Fragment>
     );
     }*/


// WEBPACK FOOTER //
// ./src/components/wrappers/MainWrapper.js